//  @flow

import * as React from 'react';

import './style.css';

type ModalProps = {
  active: boolean,
  children: React.Node,
  transparent: boolean,
  slideIn: boolean,
  toogleModal: () => {},
  closeButtonStyle: ''
};

const Modal = ({
  active,
  children,
  style,
  transparent,
  toogleModal,
  slideIn,
  className,
  closeButtonStyle
}: ModalProps) =>
  active ? (
    <div
      style={{
        backgroundColor: transparent ? 'rgba(0, 0, 0, 0.5)' : 'white',
        animation: slideIn ? 'slideIn 500ms ease forwards' : '',
        ...style
      }}
      className={`modal-container ${className}`}>
      {toogleModal ? (
        <button
          style={{ color: transparent ? 'white' : 'black' }}
          onClick={toogleModal}
          className={`close-box ${closeButtonStyle}`}>
          <i className="fas fa-times"></i>
        </button>
      ) : null}
      {children}
    </div>
  ) : null;

Modal.defaultProps = {
  transparent: true,
  toogleModal: null,
  slideIn: false
};

export default Modal;



// WEBPACK FOOTER //
// ./src/Components/Modal/index.js